"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var validationMessages = {
    array: 'sprinxFormsValidation/array',
    arrayContains: 'sprinxFormsValidation/arrayContains',
    arrayEmpty: 'sprinxFormsValidation/arrayEmpty',
    arrayEnum: 'sprinxFormsValidation/arrayEnum',
    arrayLength: 'sprinxFormsValidation/arrayLength',
    arrayMax: 'sprinxFormsValidation/arrayMax',
    arrayMin: 'sprinxFormsValidation/arrayMin',
    arrayReducedEquals: 'sprinxFormsValidation/arrayReducedEquals',
    arrayUnique: 'sprinxFormsValidation/arrayUnique',
    boolean: 'sprinxFormsValidation/boolean',
    classInstanceOf: 'sprinxFormsValidation/classInstanceOf',
    currency: 'sprinxFormsValidation/currency',
    date: 'sprinxFormsValidation/date',
    dateGt: 'sprinxFormsValidation/dateGt',
    dateGte: 'sprinxFormsValidation/dateGte',
    dateLt: 'sprinxFormsValidation/dateLt',
    dateLte: 'sprinxFormsValidation/dateLte',
    dateMax: 'sprinxFormsValidation/dateMax',
    dateMin: 'sprinxFormsValidation/dateMin',
    email: 'sprinxFormsValidation/email',
    emailEmpty: 'sprinxFormsValidation/emailEmpty',
    emailMax: 'sprinxFormsValidation/emailMax',
    emailMin: 'sprinxFormsValidation/emailMin',
    enumValue: 'sprinxFormsValidation/enumValue',
    equalField: 'sprinxFormsValidation/equalField',
    equalValue: 'sprinxFormsValidation/equalValue',
    forbidden: 'sprinxFormsValidation/forbidden',
    function: 'sprinxFormsValidation/function',
    luhn: 'sprinxFormsValidation/luhn',
    mac: 'sprinxFormsValidation/mac',
    number: 'sprinxFormsValidation/number',
    numberEqual: 'sprinxFormsValidation/numberEqual',
    numberInteger: 'sprinxFormsValidation/numberInteger',
    numberMax: 'sprinxFormsValidation/numberMax',
    numberMin: 'sprinxFormsValidation/numberMin',
    numberNegative: 'sprinxFormsValidation/numberNegative',
    numberNotEqual: 'sprinxFormsValidation/numberNotEqual',
    numberPositive: 'sprinxFormsValidation/numberPositive',
    object: 'sprinxFormsValidation/object',
    objectID: 'sprinxFormsValidation/objectID',
    objectMaxProps: 'sprinxFormsValidation/objectMaxProps',
    objectMinProps: 'sprinxFormsValidation/objectMinProps',
    objectStrict: 'sprinxFormsValidation/objectStrict',
    phoneNumber: 'sprinxFormsValidation/phoneNumber',
    required: 'sprinxFormsValidation/required',
    string: 'sprinxFormsValidation/string',
    stringAlpha: 'sprinxFormsValidation/stringAlpha',
    stringAlphadash: 'sprinxFormsValidation/stringAlphadash',
    stringAlphanum: 'sprinxFormsValidation/stringAlphanum',
    stringContains: 'sprinxFormsValidation/stringContains',
    stringEmpty: 'sprinxFormsValidation/stringEmpty',
    stringEnum: 'sprinxFormsValidation/stringEnum',
    stringHex: 'sprinxFormsValidation/stringHex',
    stringLength: 'sprinxFormsValidation/stringLength',
    stringMax: 'sprinxFormsValidation/stringMax',
    stringMin: 'sprinxFormsValidation/stringMin',
    stringNumeric: 'sprinxFormsValidation/stringNumeric',
    stringPattern: 'sprinxFormsValidation/stringPattern',
    stringSingleLine: 'sprinxFormsValidation/stringSingleLine',
    tuple: 'sprinxFormsValidation/tuple',
    tupleEmpty: 'sprinxFormsValidation/tupleEmpty',
    tupleLength: 'sprinxFormsValidation/tupleLength.',
    url: 'sprinxFormsValidation/url',
    urlEmpty: 'sprinxFormsValidation/urlEmpty',
    uuid: 'sprinxFormsValidation/uuid',
    uuidVersion: 'sprinxFormsValidation/uuidVersion',
};
exports.default = validationMessages;
//# sourceMappingURL=validationMessages.js.map